var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2452 4.20141L11.2461 4.2023L13.6013 6.52461C13.7721 6.69308 13.6655 6.99976 13.3947 6.99976H8.82387H4.70789C4.43936 6.99976 4.33408 6.68956 4.50136 6.52461L4.15029 6.16859L4.50136 6.52461L8.30185 2.77708C8.71598 2.36872 9.39335 2.36858 9.80767 2.77665C9.80782 2.77679 9.80797 2.77694 9.80811 2.77708L11.2452 4.20141Z",
    fill: "#AEB1D2",
    stroke: "#AEB1D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1925 13.7986L11.1934 13.7977L13.5485 11.4754C13.7194 11.3069 13.6128 11.0002 13.342 11.0002H8.77113H4.65516C4.38663 11.0002 4.28135 11.3104 4.44862 11.4754L4.09756 11.8314L4.44862 11.4754L8.24911 15.2229C8.66325 15.6313 9.34061 15.6314 9.75494 15.2234C9.75508 15.2232 9.75523 15.2231 9.75538 15.2229L11.1925 13.7986Z",
    fill: "#54577A",
    stroke: "#54577A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/SortAsc.559c64a2eab8e3a775d009fa6b8a5966.svg";
export { ForwardRef as ReactComponent };